// extracted by mini-css-extract-plugin
module.exports = {"InfoTooltip":"PoweredByUniverseTooltip_InfoTooltip__uJJ2K","PoweredByWrapper":"PoweredByUniverseTooltip_PoweredByWrapper__TghfH"};